import { logHelper } from '@wegic/utils';
import axios from 'axios';
import Bowser from 'bowser';
import { nanoid } from 'nanoid';
import { sessionIdKey, trackingCountKey, uniqueIdKey } from './const';
let browser;
export function getBrowser() {
    if (!browser) {
        browser = Bowser.getParser(window.navigator.userAgent);
    }
    return browser;
}
/** 获取会话的唯一id */
export function getSessionId() {
    let sessionId = sessionStorage.getItem(sessionIdKey);
    if (!sessionId) {
        sessionId = nanoid(10);
        sessionStorage.setItem(sessionIdKey, sessionId);
    }
    return sessionId;
}
/** 埋点计数 */
export function trackCount() {
    try {
        let trackingCount = Number.parseInt(sessionStorage.getItem(trackingCountKey) ?? '0');
        trackingCount++;
        sessionStorage.setItem(trackingCountKey, trackingCount.toString());
        return trackingCount;
    }
    catch {
        return 0;
    }
}
export function getUniqueId() {
    let uniqueId = localStorage.getItem(uniqueIdKey);
    let isNewUniqueId = false;
    if (!uniqueId) {
        uniqueId = nanoid(24);
        localStorage.setItem(uniqueIdKey, uniqueId);
        isNewUniqueId = true;
    }
    return {
        uniqueId,
        isNewUniqueId,
    };
}
export function getNetworkType() {
    const navigator = window.navigator;
    return navigator.connection?.effectiveType || 'unknown';
}
export function getRequestData(eventName, customProperties, config) {
    const { uniqueId, isNewUniqueId } = getUniqueId();
    const browser = getBrowser();
    const isAnonymousUser = !config.userId;
    const finalUserId = isAnonymousUser ? '' : config.userId;
    const finalEventName = config.eventPrefix ? `${config.eventPrefix}_${eventName}` : eventName;
    const data = {
        business_type: config.businessType,
        theme: config.actionToThemeMap[eventName] || 'basic_functions',
        action: finalEventName,
        distinct_id: nanoid(22),
        time: Date.now(),
        user_id: finalUserId,
        hrefUrl: window.location.href,
        uniqueid: uniqueId,
        sessionId: getSessionId(),
        count: trackCount(),
        properties: {
            browser_version: browser.getBrowserVersion(),
            browser_name: browser.getBrowserName(),
            os: browser.getOSName(),
            os_version: browser.getOSVersion(),
            network_type: getNetworkType(),
            user_agent: window.navigator.userAgent,
            device_type: browser.getPlatformType(),
            screen_magnification: `${window.devicePixelRatio}`,
            screen_resolution: `${window.screen.width}x${window.screen.height}`,
            browser_window_size: `${window.innerWidth}x${window.innerHeight}`,
            userLanguage: window.navigator.language,
            referrer_url: document.referrer,
            isNew: isNewUniqueId,
            isOnline: config.isOnline,
            ...customProperties,
            isAnonymous: config.isAnonymous,
        },
    };
    return data;
}
/** 使用 Beacon API 发送请求 */
function sendWithBeacon(url, data) {
    try {
        navigator.sendBeacon(url, JSON.stringify(data));
    }
    catch (error) {
        logHelper.error('sendWithBeacon failed', error);
        throw error;
    }
}
/** 使用 axios 发送请求 */
async function sendWithAxios(url, data) {
    try {
        await axios.post(url, data);
    }
    catch (error) {
        logHelper.error('sendWithAxios failed', error);
        throw error;
    }
}
/** 发送单个埋点 */
async function sendSingle(item, config) {
    sendWithBeacon(config.serverUrl, item);
    await sendWithAxios(config.serverUrl, item);
}
/** 发送多个埋点 */
async function sendBatch(items, config) {
    sendWithBeacon(config.serverUrl, items);
    await sendWithAxios(config.serverUrl, items);
}
/** 发送失败的兜底发送 */
async function sendFallback(items, config) {
    for (const item of items) {
        try {
            await sendSingle(item, config);
        }
        catch (error) {
            handleError(error, 'sendFallback failed', config);
        }
    }
}
/** 发送埋点请求 */
export async function sendCollectRequest(data, config) {
    if (Array.isArray(data)) {
        try {
            await sendBatch(data, config);
        }
        catch (error) {
            handleError(error, 'batch send failed, fallback', config);
            await sendFallback(data, config);
        }
    }
    else {
        try {
            await sendSingle(data, config);
        }
        catch (error) {
            handleError(error, 'single send failed, fallback', config);
            await sendFallback([data], config);
        }
    }
}
/** 处理错误 */
export function handleError(error, message, config) {
    if (config.onError) {
        try {
            config.onError(error, message);
        }
        catch (err) {
            console.error('[CollectSDK] onError failed', err);
        }
    }
}
/** 处理未初始化错误 */
export function handleNotInitializedError(config) {
    handleError(new Error('not initialized'), 'not initialized', config);
}
